module.exports = __webpack_public_path__ + "img/queue-1.ececd967.svg";